import { render, staticRenderFns } from "./BaseAsideNav.vue?vue&type=template&id=2ac0573e&scoped=true"
import script from "./BaseAsideNav.vue?vue&type=script&lang=js"
export * from "./BaseAsideNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0573e",
  null
  
)

export default component.exports